import { AudioMedia } from ".";
import { useAxios } from "../../hooks/useAxios";

type CreateAudioMediaParams = Pick<AudioMedia, "fileUrl" | "userId" | "topicId" | "startTime" | "endTime">;

type AudioMediaEndpointConfig = {
  CREATE_AUDIO_MEDIA: EndpointConfig<
    CreateAudioMediaParams,
    AudioMedia
  >;
};

// Audio Media api specific logic
const requestInitialisers: RequestConfig<AudioMediaEndpointConfig> = {
  CREATE_AUDIO_MEDIA: (
    params => ({
      url: "/audio-media",
      method: "POST",
      data: params
    })
  )
};

export const useAudioMediaApi: UseApiRequest<AudioMediaEndpointConfig> = name => useAxios(requestInitialisers[ name ]);
